export default {
    SampleDataLocalStorageKey: '_pendo_SAMPLE_DATA',
    SampleDataSubNameUS: 'PENDO_SAMPLE_DATA_SUB',
    SampleDataSubNameEU: 'PENDO_SAMPLE_DATA_SUB_EU',
    SampleDataTooltipDismissedKey: '_pendo_SAMPLE_DATA_TOOLTIP_DISMISSED',
    BackToSampleData: '_pendo_BACK_TO_SAMPLE_DATA',
    LastInstallInstructions: '_pendo_LAST_INSTALL_INSTRUCTIONS',
    WelcomeMatLocalStorageKey: '_pendo_SAMPLE_DATA_WELCOME_MAT',
    WelcomeMatSeenDatastoreKey: 'welcomeMatSeen',
    WelcomeMatGuideName1: '[Do Not Delete] Welcome Guide Feature Adoption',
    WelcomeMatGuideName2: '[Do Not Delete] Welcome Guide Funnels & Retention',
    WelcomeMatGuideName3: '[Do Not Delete] Welcome Guide Guides',
};
